import { cn } from "@/lib/utils";
import { MessageEntity } from "@/indexedDB/types";

import { useTranslation } from "react-i18next";
import { useNavigationState } from "@/zustand/NavigationState";
import { MessageCircle } from "lucide-react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  parentMessage: MessageEntity;
}

export default function CommentCount({ parentMessage, className }: Props) {
  const { t } = useTranslation();

  const setActiveThreadId = useNavigationState(
    (state) => state.setActiveThreadId,
  );

  if (!parentMessage.commentCount || parentMessage.commentCount === 0) {
    return null;
  }
  return (
    <div
      onClick={() => setActiveThreadId(parentMessage.id)}
      className={cn("lg:cursor-pointer", className)}
    >
      <div className="contents">
        <div
          className={cn(
            "flex items-center gap-1 rounded-b-xl border border-border bg-primary/5 px-2 py-1 align-middle text-sm",
            parentMessage.isOutgoing ? "rounded-tl-xl" : "rounded-tr-xl",
          )}
        >
          <MessageCircle size={16} />

          <span>{parentMessage.commentCount}</span>

          <span>{t("threads.comments")}</span>
        </div>
      </div>
    </div>
  );
}
